import _ from 'lodash';
import React, { Fragment } from 'react';
import autobind from 'autobind-decorator';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css';

import { observer, inject } from 'mobx-react';
import { Route } from 'react-router-dom';

import { wrapGrid } from 'client/shared/util';
import { CancelSubscriptionConfirmDialog, MusicLibrary } from 'client/shared/components';

import Navigation from './navigation';
import Header from './header';
import Bio from './bio';

import SubscriptionModal from './subscribe-modal';

const Tracks = wrapGrid((props) => ( <MusicLibrary trackListMode { ...props } /> ));

@inject('membersBFFStore', 'userStore')
@observer
export default class Artist
extends React.Component {
	state = {
		cancelConfirmOpen: false
	}

	constructor (props) {
		super(props);

		this.fetchData();
	}

	
	fetchData () {
		const { match: { params: { id } } } = this.props;
		this.props.membersBFFStore.fetchArtistSummary(id);
	}

	@autobind
	handleAskCancel () {
		this.setState({ cancelConfirmOpen: true });
	}

	@autobind
	handleDismissCancel () {
		this.setState({ cancelConfirmOpen: false });
	}

	@autobind
	async handleConfirmCancel () {
		const { userStore, match: { params: { id } } } = this.props;
		const subscription = userStore.getLoggedInUser()?.getSubscription(id);

		if (!subscription) {
			this.setState({ cancelConfirmOpen: false });
			return;
		}

		try {
			await userStore.cancelSubscription(subscription.id);
		} finally {
			this.setState({ cancelConfirmOpen: false });
		}
	}

	renderSubscribeBtn (imagePath) {
		const {
			membersBFFStore,
			userStore,
			match: { params: { id } }
		} = this.props;

		if (userStore.isSubscribing) {

			return (
				<div style={{height: '7vh'}}>
					<em>Subscribing...</em>
				</div>
			);
		}

		if (membersBFFStore.isLoading || !membersBFFStore.artistSummary) {
			return <div style={{height: '7vh'}} />;
		}

		const subscription = userStore.getLoggedInUser()?.getSubscription(id);
		const subscribeModalFlowOpen =
			membersBFFStore.isModalDataSuccess ||
			membersBFFStore.isModalDataLoading ||
			membersBFFStore.isModalDataError;

		if (_.isEmpty(subscription) || subscribeModalFlowOpen) {

			return (
				<SubscriptionModal
					artist={ membersBFFStore.artistSummary }
					imagePath={ imagePath }
				/>
			);
		}

		const artistName = membersBFFStore.artistSummary.name;

		return (
			<Fragment>
				<button
					type="button"
					data-ta="cancel-subscription"
					className="add-button button margin-top-1"
					disabled={ userStore.isLoading }
					onClick={ this.handleAskCancel }
				>
					Subscribed
				</button>
				<CancelSubscriptionConfirmDialog
					isOpen={ this.state.cancelConfirmOpen }
					artistName={ artistName }
					onConfirm={ this.handleConfirmCancel }
					onClose={ this.handleDismissCancel }
				/>
			</Fragment>
		);
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	render() {
		const { membersBFFStore } = this.props;

		if (membersBFFStore.isLoading) {

			return <div className="loading-spinner large text-center" style={{height: '65vh'}}></div>;
		}

		const artist = membersBFFStore.artistSummary;

		if (_.isEmpty(artist)) {

			return <div className="loading-spinner large text-center" style={{height: '65vh'}}></div>;
		}

		return (
			<Fragment>
				<div className="grid-x header-grid">
					<div className="cell small-12">
						<Header artist={ artist } />
					</div>
				</div>

				<div className="artist-navbar-container padding-left-2">
					{ this.renderSubscribeBtn(artist.bannerImage) }
					<div>
						<Navigation artist={ artist } id={ artist.id } />
					</div>
				</div>

				<div className="grid-x grid-padding-x" style={{ paddingBottom: '22vh' }}>
					<div className="cell small-12">
						<Route path="/artist/:id/tracks" render={() => (
							<Tracks
								artist={ artist }
								songList={ artist.songs }
							/>
						)}/>
						<Route path="/artist/:id/bio" component={ wrapGrid(Bio) } />
					</div>
				</div>
			</Fragment>
		);
	}
}
